import {
  TableColumns,
  TableFilterTab,
} from '../../../../../../ui-components/lib/table/table.model';

export const DEPARTMENTS_COLUMN_IDENTIFIERS = {
  STATUS: 'status',
};

export const DEPARTMENTS_COLUMNS_SORT: TableColumns[] = [
  { header: '' },
  {
    header: 'department_list_screen_department_table_header',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'name][type',
  },
  {
    header: 'department_list_screen_parent_table_header',
    isSortable: true,
    sortKey: 'parent][type',
  },
  {
    header: 'department_list_screen_department_manager_table_header',
    isSortable: true,
    sortKey: 'direct_manager][type',
  },
  {
    header: 'department_list_screen_total_users_table_header',
    isSortable: true,
    sortKey: 'users_count][type',
  },
  {
    header: 'department_list_screen_status_table_header',
  },
  { header: '' },
];

export const DEPARTMENTS_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'active',
    identifier: 'active',
    label: 'table_filter_tab_active_label',
    active: false,
    iconName: 'active',
  },
  {
    key: 'inactive',
    identifier: 'inactive',
    label: 'table_filter_tab_inactive_label',
    active: false,
    iconName: 'inactive',
  },
];
